import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// Página de destino após o login (e ao restaurar a sessão no Electron)
const POST_LOGIN_PATH = '/finance/chat';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      // Sempre cai no Assistente IA, a menos que tenha vindo de um deep-link protegido
      navigate(location?.state?.from ? location?.state?.from : POST_LOGIN_PATH, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
}
